import Request from '../data/request'
import Expense from "../../model2/expenses/expense/expense"

export default class ApiExpenses {

    static create(expense:Expense) {
        return new Request(this, 'POST', 'expenses/create', expense.toJSON())
    }

    static getAllExpenses(params?: any) {
        return new Request(this, 'POST', 'uds/expenses', params);
    }

    static getExpense(expenseId: ID) {
        return new Request(this, 'GET', 'expenses/{0}'.f(expenseId));
    }

    static update(expenseId: ID, params:any) {
        return new Request(this, 'PUT', 'expenses/{0}'.f(expenseId), params);
    }

    static delete(expenseId:ID) {
        return new Request(this, 'DELETE', 'expenses/{0}'.f(expenseId));
    }

    static loadForTask(taskId:ID) {
        return new Request(this, 'POST', 'expenses/select',{
            taskIds : [taskId]
        }).promise();
    }

}
